import { render, staticRenderFns } from "./CompleteRegistrationComponent.vue?vue&type=template&id=3cb090c4&"
import script from "./CompleteRegistrationComponent.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistrationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports